import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import useCurrentMerchant from 'hooks/useCurrentMerchant'
import useCurrentMerchantUser from 'hooks/useCurrentMerchantUser'
import useFlag from 'hooks/useFlag'
import { buildTranslate } from 'locales'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap-five'
import Helmet from 'react-helmet'
import { useAbility } from 'utilities/ability'
import ButtonRow from './ButtonRow'
import Metrics from './Metrics'
import NeedsAttention from './NeedsAttention'
import PromoCarousel from './PromoCarousel'
import { RbacButtonRow } from './RbacButtonRow'

const t = buildTranslate('home')

const Home: React.FC = () => {
  const [css] = useStyletron()
  const merchantUser = useCurrentMerchantUser()
  const merchant = useCurrentMerchant()
  const ability = useAbility()
  const rbacEnabled = useFlag('role-based-access-control', false)
  const roles =
    merchant && merchantUser && merchantUser.roles
      ? merchantUser.roles[merchant.id]
      : []
  const welcome = merchantUser?.first_name
    ? t('welcome_name', { name: merchantUser?.first_name })
    : t('welcome')

  return (
    <div
      className={`${css({
        minHeight: '100%',
      })} grey-05-bkg`}
    >
      <Helmet>
        <title>{t('page_title')}</title>
      </Helmet>
      <Container>
        <Row className="my-xxl">
          <Col>
            <Text.Header1 className="mt-0">{welcome}</Text.Header1>
            <Text.BodyText2 color="grey70">{t('subtitle')}</Text.BodyText2>
          </Col>
        </Row>
        <NeedsAttention />
        {rbacEnabled ? <RbacButtonRow /> : <ButtonRow roles={roles} />}
        <Row>
          <Col>
            <PromoCarousel />
          </Col>
        </Row>
        {merchant &&
        (rbacEnabled
          ? ability.can('access', 'Reports')
          : roles?.includes('admin')) ? (
          <Metrics merchant={merchant} />
        ) : null}
      </Container>
    </div>
  )
}

export default Home
